import { forwardRef } from 'react';
import { Typography } from '../typography';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  { Component = 'span', normalize = true, inline = false, ...props },
  forwardedRef
) {
  return (
    <Typography
      {...props}
      Component={Component}
      baseClassName={css.root}
      normalize={normalize}
      inline={inline}
      ref={forwardedRef}
    />
  );
});
